import { CurrencyPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { Subject } from 'rxjs';
import { EcryptServiceService } from 'src/app/core/auth/EcryptionService/ecrypt-service.service';
import { CommonService } from 'src/app/services/common.service';
import { ConfigService } from 'src/app/services/config.service';

import { CurrencyConversionService } from 'src/app/services/currency-conversion.service';
import { formatScientificNumber } from '../utils/calsoft-validators';


@Pipe({
  name: 'currencyConvert'
})
export class CurrencyConvertPipe implements PipeTransform {

  currencyRate: any;
  countryCode: string;
  decimalDigit: any = 2;
  currencyBase: string | null = null;



  constructor(private currencyConversionService: CurrencyConversionService,
    private currencyPipe: CurrencyPipe,

    private ecryptService: EcryptServiceService
  ) {


  }

  transform(value: any, mode: 'full' | 'symbol' = 'full', isPaise: boolean = false): string | null {
    if (value === null || value === undefined || value === '' || value === '--') {
      return mode === 'full' ? null : '';
    }

    // Expand scientific notation to regular number string
    value = formatScientificNumber(value);

    if (value === null || value === undefined || value === '' || value === '--') {
      return mode === 'full' ? null : '';
    }

    const encryptedData = localStorage.getItem('crmSettingsData');
    if (encryptedData) {
      try {
        const decrypted = this.ecryptService.decryptionAES(encryptedData);
        const data = JSON.parse(decrypted);

        if (data != null) {
          this.countryCode = data['currencyBase'] || 'INR';
        } else {
          this.countryCode = 'INR';
        }
      } catch (error) {
        console.error("Failed to decrypt crmSettingsData:", error);
      }
    }

    if (!this.countryCode) {
      this.countryCode = 'INR';
    }

    const symbol = this.getCurrencySymbol(this.countryCode);

    if (mode === 'symbol') {
      return symbol;
    }

    // Default: return formatted currency string
    let numericValue = Number(value);
    if (isNaN(numericValue) && typeof value !== 'string') return null;

    if (isPaise && !isNaN(numericValue)) {
      numericValue = numericValue / 100;
      value = numericValue;
    }

    const convertedValue = value;
    const digitsInfo = `1.${this.decimalDigit}-${this.decimalDigit}`;

    try {
      const formattedCurrency = this.currencyPipe.transform(convertedValue, this.countryCode, 'symbol-narrow', digitsInfo);
      if (formattedCurrency && !/[eE]/.test(formattedCurrency)) {
        return formattedCurrency.replace(/(\D)(\d)/, '$1 $2');
      }
    } catch (e) {
      // Fall through to manual formatting
    }

    return this.formatLargeNumberCurrency(convertedValue, symbol);
  }

  private getCurrencySymbol(code: string): string {
    try {
      const formatted = this.currencyPipe.transform(0, code, 'symbol-narrow', '1.0-0');
      if (formatted) {
        const symbol = formatted.replace(/[0-9\s,\.\u00A0\u202F\u2009\-]+/g, '').trim();
        if (symbol) return symbol;
      }
    } catch (e) {}
    return this.getFallbackSymbol(code);
  }

  private formatLargeNumberCurrency(val: any, symbol: string): string {
    const expanded = String(formatScientificNumber(val)).trim();
    if (!expanded || expanded === 'null' || expanded === 'undefined' || expanded === '--') return '--';
    const parts = expanded.split('.');
    const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    let decimalPart = parts[1] || '';
    if (this.decimalDigit > 0) {
      decimalPart = (decimalPart + '0000').slice(0, this.decimalDigit);
      return symbol ? `${symbol} ${integerPart}.${decimalPart}` : `${integerPart}.${decimalPart}`;
    }
    return symbol ? `${symbol} ${integerPart}` : integerPart;
  }

  private getFallbackSymbol(code: string | null): string {
    switch ((code || '').toUpperCase()) {
      case 'INR': return '₹';
      case 'USD': return '$';
      case 'EUR': return '€';
      case 'GBP': return '£';
      case 'JPY': return '¥';
      default: return code || '';
    }
  }
}
